import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5146b6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center text-danger my-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Loading...", -1))
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_icon = _resolveComponent("b-icon")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_prescription_details = _resolveComponent("prescription-details")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_b_card, { title: "Doctor Queue" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_button, {
                    variant: "outline-secondary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doctorQueueTable.refresh()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Refresh ")
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_button, {
                    variant: "outline-info",
                    onClick: _ctx.selectAll
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Select All ")
                    ], undefined, true),
                    _: 1
                  }, 8, ["onClick"])
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_button, {
                    variant: "success",
                    disabled: _ctx.disableSubmit,
                    onClick: _ctx.submitScripts
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Submit ")
                    ], undefined, true),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_table, {
                    ref: "doctorQueueTable",
                    items: _ctx.itemProvider,
                    fields: _ctx.fields,
                    "api-url": "api/DoctorQueue",
                    "tbody-tr-class": _ctx.colorCodeTable,
                    "sort-icon-left": ""
                  }, {
                    "table-busy": _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_b_spinner, { class: "align-middle" }),
                        _hoisted_2
                      ])
                    ]),
                    [`cell(selected)`]: _withCtx((data) => [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event)),
                        type: "checkbox",
                        value: data.item
                      }, null, 8, _hoisted_3), [
                        [_vModelCheckbox, _ctx.selected]
                      ])
                    ]),
                    [`cell(patientPay)`]: _withCtx((data) => [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(data.value), 1)
                    ]),
                    [`cell(details)`]: _withCtx((data) => [
                      _createVNode(_component_b_button, {
                        onClick: ($event: any) => (_ctx.selectedPrescription = data.item)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_icon, {
                            icon: "clipboard",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" details ")
                        ], undefined, true),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["items", "fields", "tbody-tr-class"])
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_b_modal, {
        modelValue: _ctx.selectedPrescriptionExists,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedPrescriptionExists) = $event)),
        size: "xl",
        title: "Prescription Details",
        "hide-footer": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_prescription_details, {
            modelValue: _ctx.selectedPrescription,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPrescription) = $event))
          }, null, 8, ["modelValue"])
        ], undefined, true),
        _: 1
      }, 8, ["modelValue"])
    ], undefined, true),
    _: 1
  }))
}